
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceSupportCallGravar: 'supportCall.gravar',
  nmInterfaceSupportCallPesquisar: 'supportCall.pesquisarServiceRequest',
  nmInterfacePersonPesquisar: 'physicalPerson.pesquisarSelecaoComplete',
  nmInterfaceConsumerUnitPesquisar: 'consumerUnit.pesquisarSelecaoSupportCall',
  nmInterfaceSupportCallAlterar: 'supportCall.alterar',
  nmInterfacePesquisarByIdDetalhar: 'supportCall.pesquisarByIdDetalhar',
  nmInterfacePesquisarById: 'supportCall.pesquisarById',
  nmInterfaceSupportCallDetalhar: 'supportCall.detalhar',
  nmInterfaceFilePesquisar: 'supportCallChangeFile.pesquisarBySupportCall',

  loadDatatable: async function () {
    return await repository.resolveDatatable(this.nmInterfaceConsumerUnitCategoryPesquisarConsumerUnit)
  },

  async pesquisarFiles (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceFilePesquisar, { ...params })
  },

  async loadDatatableModel (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceConsumerUnitCategoryPesquisarConsumerUnit, { ...params })
  },

  async loadForm () {
    return await repository.resolve(this.nmInterfaceConsumerUnitCategoryGravar)
  },

  async loadFormGravar () {
    return await repository.resolve(this.nmInterfaceSupportCallGravar)
  },

  async loadFormAlterar (params) {
    return await repository.resolve(this.nmInterfaceSupportCallAlterar, params)
  },

  async getPerson (idField) {
    return await repository.resolveDatatableModel(this.nmInterfacePersonPesquisar, { id: idField })
  },

  async getConsumerUnit (idConsumerUnit) {
    return await repository.resolveDatatableModel(this.nmInterfaceConsumerUnitPesquisar, { id: idConsumerUnit })
  },

  async pesquisarServiceOrderDataTable (consumerUnit, serviceRequest) {
    return await repository.resolveDatatable(this.nmInterfaceSupportCallPesquisar, { consumerUnit: consumerUnit, serviceRequest: serviceRequest })
  },

  async loadFormPesquisar () {
    return await repository.resolve(this.nmInterfaceSupportCallPesquisar)
  },

  async pesquisarServiceOrder (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceSupportCallPesquisar, { ...params })
  },

  async pesquisarServiceOrderById (id) {
    return await repository.resolve(this.nmInterfacePesquisarById, { id: id })
  },

  async pesquisarServiceOrderByIdDetalhar (id) {
    return await repository.resolve(this.nmInterfacePesquisarByIdDetalhar, { id: id })
  },

  async downloadFile (filePath, nmIdentificacaoParserFile) {
    return await repository.downloadFile(
      filePath,
      null,
      nmIdentificacaoParserFile
    )
  },

  async gravarServiceOrder (params) {
    return await repository.create(this.nmInterfaceSupportCallGravar, { ...params })
  },

  async alterarServiceOrder (params) {
    return await repository.update(this.nmInterfaceSupportCallAlterar, { ...params })
  },

  async loadFormDetalhar () {
    return await repository.resolve(this.nmInterfaceSupportCallDetalhar)
  },

  async deleteCategory (id) {
    return await repository.delete(this.nmInterfaceConsumerUnitCategoryExcluir, { id })
  }
}
